import { useState, useEffect } from 'react';

const heroStats = [
  { label: '收录影片', value: '50,000+' },
  { label: '日均更新', value: '30+部' },
  { label: '累计观影', value: '2.8亿次' },
];

export default function Hero() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { setLoaded(true); }, []);

  return (
    <section id="hero" className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20warm%20amber%20spotlights%20and%20deep%20red%20velvet%20curtains%2C%20dramatic%20atmospheric%20lighting%2C%20film%20projector%20beam%20cutting%20through%20darkness%2C%20elegant%20and%20nostalgic%20cinema%20aesthetic%2C%20no%20people%2C%20rich%20textures%2C%20artistic%20composition&width=1600&height=900&seq=hero-bg-8090&orientation=landscape"
          alt="8090影视 - 电影大全平台"
          className="w-full h-full object-cover object-top"
          onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/75"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className={`flex-1 text-center lg:text-left w-full transition-all duration-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-5">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-xs font-medium text-primary-300 whitespace-nowrap">本周热门推荐</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              8090影视
              <span className="block text-primary-400 text-xl sm:text-2xl md:text-3xl lg:text-4xl mt-2">你的专属电影大全平台</span>
            </h1>

            <p className="text-sm md:text-base text-white/70 leading-relaxed mt-4 max-w-xl mx-auto lg:mx-0">
              8090影视聚合最新电影、经典电影与高清电影资源，涵盖华语电影与欧美电影丰富片库，
              从院线热映到经典佳作一应俱全。每日更新内容，高清画质流畅播放，
              为每一位影迷打造极致的在线观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-white font-heading">{stat.value}</div>
                  <div className="text-xs text-white/50 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看热播榜单
              </a>
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-line"></i>
                浏览片库索引
              </a>
            </div>
          </div>

          <div className={`flex-1 w-full max-w-md lg:max-w-none transition-all duration-700 delay-200 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="relative rounded-xl overflow-hidden aspect-[3/4] max-w-[340px] mx-auto lg:mx-0 lg:ml-auto">
              <img
                src="https://readdy.ai/api/search-image?query=A%20collection%20of%20classic%20Chinese%20and%20Hollywood%20film%20posters%20overlapping%20artistically%20on%20a%20dark%20textured%20wall%2C%20warm%20cinematic%20lighting%2C%20nostalgic%20movie%20theater%20atmosphere%2C%20film%20reels%20and%20projector%20elements%2C%20rich%20red%20and%20gold%20accents%2C%20artistic%20composition%2C%20no%20text%20on%20posters&width=800&height=1066&seq=hero-poster-8090&orientation=portrait"
                alt="8090影视 - 最新电影与经典电影"
                className="w-full h-full object-cover"
                onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center gap-2 text-white/90 text-xs">
                  <i className="ri-movie-2-line"></i>
                  <span className="whitespace-nowrap">华语电影 · 欧美电影 · 经典回顾</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}